"use strict";

(function () {
  "use strict";

  config.$inject = ["$stateProvider"];
  angular.module("courses").config(config);

  function config($stateProvider) {
    $stateProvider.state("courses", {
      url: "/courses",
      templateUrl: "app/pages/courses/courses.html",
      controller: "CoursesCtrl",
      controllerAs: "vm",
      resolve: {
        ready: function ready($q, $rootScope) {
          var deferred = $q.defer();
          if ($rootScope.$user) {
            deferred.resolve("");
          } else {
            $rootScope.$watch(function () {
              return $rootScope.$user;
            }, function () {
              if ($rootScope.$user) {
                deferred.resolve("");
              }
            }, true);
          }
          return deferred.promise;
        }
      }
    });
  }
})();